__turbopack_context__.v({
  "modalContainer": "Modal-module-scss-module__ws1CfW__modalContainer",
  "overlay": "Modal-module-scss-module__ws1CfW__overlay",
});
